// # Support Requests Component for Admin
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../auth/state';
import DashboardHeader from '../../components/DashboardHeader';
import DashboardFooter from '../../components/DashboardFooter';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../auth/firebase';
import cacheManager from '../../auth/cache_manager';
import './support_requests.css';

const SupportRequests = () => {
  const navigate = useNavigate();
  const { isAdmin, user } = useAuthStore();
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (user && user.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, [user]);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (user && user.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', user.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${user.uid}`, updatedUserData);
        }

        // # Dispatch theme change event for footer and other components
        const themeChangeEvent = new CustomEvent('theme_change', {
          detail: { isDark: newTheme }
        });
        window.dispatchEvent(themeChangeEvent);
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Redirect if not admin
  React.useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);

  return (
    <div className={`sprt_req_admin-page ${isDarkMode ? 'sprt_req_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="sprt_req_admin-content">
        <div className="sprt_req_admin-header">
          <button 
            className="sprt_req_back-button"
            onClick={() => navigate('/admin')}
          >
            <i className="fas fa-arrow-left"></i> Back to Dashboard
          </button>
          <h1>Support Requests</h1>
        </div>

        <div className="sprt_req_coming-soon-container">
          <i className="fas fa-headset sprt_req_coming-soon-icon"></i>
          <h2>Support System Coming Soon</h2>
          <p>Our support ticket management system is under development.</p>
          <p>Features will include:</p>
          <ul>
            <li>View and manage support tickets</li>
            <li>Track ticket status and priority</li>
            <li>Assign tickets to support staff</li>
            <li>Monitor response times</li>
            <li>Generate support analytics</li>
          </ul>
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
};

export default SupportRequests; 